export default __webpack_public_path__ + "static/media/cabinet1-before-2048w.2a10daa5.avif";